import { Component } from 'preact'
import axios from 'axios'
import Header from '../../header'
import CategoryManager from '../../category/control/CategoryManager'
import EmptyPage from '../../empty-page/EmptyPage'
import AlertComponent from '../../ui-components/AlertComponent'
import ButtonControl from '../../button-control'

class CommunityCategoryManager extends Component {
  constructor (props) {
    super()

    this.state = {
      messageType: null,
      categoryList: JSON.parse(props.categories),
      isLoading: false
    }

    this.originalCategoryList = JSON.parse(props.categories)
    this.onUnload = this.onUnload.bind(this)
    this.saveChanges = this.saveChanges.bind(this)
    this.updateCategoriesOrder = this.updateCategoriesOrder.bind(this)
  }

  saveChanges () {
    this.setState({
      isLoading: true
    })

    const newData = this.state.categoryList

    axios.post('/settings/category/reorder', newData)
      .then(() => {
        this.setState({
          messageType: 'success'
        },
        () => window.setTimeout(
          () => this.setState({
            messageType: null
          }), 5000))

        this.originalCategoryList = this.state.categoryList
      })
      .catch(() => {
        this.setState({
          messageType: 'error'
        },
        () => window.setTimeout(
          () => this.setState({
            messageType: null
          }), 5000))
      })
      .finally(() => {
        this.setState({
          isLoading: false
        })
      })
  }

  hasChanged () {
    return JSON.stringify(this.state.categoryList) !== JSON.stringify(this.originalCategoryList)
  }

  componentDidMount () {
    window.addEventListener('beforeunload', this.onUnload)
  }

  componentWillUnmount () {
    window.removeEventListener('beforeunload', this.onUnload)
  }

  onUnload (event) {
    if (this.hasChanged()) {
      event.preventDefault()
      event.returnValue = ''
    }
  }

  updateCategoriesOrder (newOrderedList) {
    this.setState({
      categoryList: newOrderedList
    })
  }

  render ({
    defaultCdn
  }, {
    categoryList: categories,
    isLoading,
    messageType
  }) {
    return (
      <div class='category-manager_container community-category-control'>
        <Header
          title='Community'
          disableSaveButton
          disableCancelButton
          customButtons={[
            <ButtonControl
              class='js-submit'
              title='Save changes'
              variant='success'
              onClick={this.saveChanges}
              isLoading={isLoading}
            />,
            <a href='/settings/category/new'>
              <ButtonControl
                title='Add parent category'
                variant='primary'
              />
            </a>
          ]}
        />
        <AlertComponent messageType={messageType} />
        {
          !categories.length ? (
            <EmptyPage
              img_src={`${defaultCdn}/images/empty_page.png`}
              header='Your community is still empty'
              text='Start now by adding the first parent category.'
              button={{
                link: '/settings/category/new',
                text: 'Add parent category'
              }}
            />
          ) : <CategoryManager
            addCategoryLink='/settings/category/new'
            editCategoryLink='/settings/category/edit'
            updateCategoriesOrder={this.updateCategoriesOrder}
            categories={categories} />
        }
      </div>
    )
  }
}

export default CommunityCategoryManager
